module.exports = __webpack_public_path__ + "static/media/live_event3.25d5303f.jpeg";